import "@fontsource/lexend";
import "@fontsource/lexend/100.css";
import "@fontsource/lexend/200.css";
import "@fontsource/lexend/300.css";
import "@fontsource/lexend/400.css";
import "@fontsource/lexend/500.css";
import "@fontsource/lexend/600.css";
import "@fontsource/lexend/700.css";
import "@fontsource/lexend/800.css";
import "@fontsource/lexend/900.css";
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './policy-page.css';

export default function CommunityGuidelinesPage() {
    const [searchParams] = useSearchParams();
    const hideNav = searchParams.get('hideNav') === 'true';

    useEffect(() => {
        document.title = "Marlo - Community Guidelines";
    }, []);

    return (
        <div className="policy-page">
            {!hideNav && <Header />}
            <div className="policy-content">
                <h1>Community Guidelines</h1>
                <br /><br />

                <h2>Community Guidelines (Detailed)</h2>
                <br />
                Our platform aims to provide a welcoming, inclusive, and safe environment for users to interact, share interests, and build connections. To ensure a positive experience for everyone, we have created the following detailed community guidelines:
                <br /><br />

                <ol>
                    <li><b>Respectful Communication:</b> Be polite, kind, and considerate towards others. Avoid using aggressive, offensive, or disrespectful language. Keep discussions civil and refrain from personal attacks, name-calling, or derogatory remarks.</li>
                    <br />
                    <li><b>No Harassment or Bullying:</b> Do not engage in any behavior that intimidates, threatens, or demeans other users. This includes stalking, cyberbullying, or any other form of harassment based on race, gender, religion, or other protected characteristics.</li>
                    <br />
                    <li><b>Appropriate Content:</b> Ensure that the content you post is suitable for a diverse audience. Do not share explicit, violent, or disturbing material, including graphic images, videos, or texts. Be mindful of potentially triggering or offensive content and use content warnings when necessary.</li>
                    <br />
                    <li><b>Constructive and Relevant Discussions:</b> When participating in conversations or group activities, contribute positively and stay focused on the topic at hand. Avoid derailing discussions with irrelevant comments, spam, or excessive self-promotion.</li>
                    <br />
                    <li><b>Respect Intellectual Property:</b> Do not post copyrighted material, such as articles, images, or videos, without proper permission or attribution. Always credit the original creator and respect their rights to their intellectual property.</li>
                    <br />
                    <li><b>Privacy Protection:</b> Be cautious about sharing personal information about yourself or others, including contact details, location data, or private conversations. Obtain consent before sharing any sensitive or personal information about others.</li>
                    <br />
                    <li><b>Legal Compliance:</b> Adhere to all applicable laws and regulations while using our platform. Do not engage in illegal activities, promote or share harmful substances, or encourage others to participate in unlawful behavior.</li>
                    <br />
                    <li><b>No Spam or Scams:</b> Refrain from posting unsolicited advertisements, promotional material, or fraudulent schemes. Do not use our platform for phishing, spreading malware, or engaging in any deceptive practices.</li>
                    <br />
                    <li><b>Account Integrity:</b> Use your real identity on our platform and do not impersonate others, create fake accounts, or misrepresent your affiliations.</li>
                    <br />
                    <li><b>Responsible Reporting:</b> If you encounter content or behavior that violates our community guidelines, use the provided reporting tools to notify our team. Do not engage in retaliatory actions or public shaming.</li>
                </ol>
                <br />

                We actively monitor and enforce these guidelines to maintain a respectful and inclusive atmosphere. Failure to comply with these guidelines may result in content removal, account suspension, or termination, depending on the severity of the violation. By using our platform, you agree to adhere to these guidelines and contribute to a positive community experience for all users.
                <br /><br />

                <hr style={{border: '1px solid #eee', margin: '30px 0'}} />

                <h2>Marlo Community Guidelines</h2>
                <br />
                Welcome to the Marlo community! We're thrilled to have you here. Marlo is designed to connect like-minded individuals for unforgettable adventures, anytime, anywhere. To maintain a respectful and inclusive environment, we've established the following guidelines:
                <br /><br />

                <ol>
                    <li><b>Be Respectful</b>
                        <ul>
                            <li>Treat all members with kindness and understanding.</li>
                            <li>Avoid any form of harassment, hate speech, or discriminatory behavior.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>Stay Authentic</b>
                        <ul>
                            <li>Use your real name and provide genuine information.</li>
                            <li>Avoid impersonating others or providing misleading information.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>No Inappropriate Content</b>
                        <ul>
                            <li>Avoid sharing explicit or sensitive content.</li>
                            <li>Respect community standards. Anything deemed offensive, harmful, or inappropriate will be removed.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>Age Requirement</b>
                        <ul>
                            <li>Marlo is intended for users aged 18 and above.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>Respect Privacy</b>
                        <ul>
                            <li>Do not share someone else's private information without their explicit consent.</li>
                            <li>Report any breaches of privacy you come across.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>Safe Interactions</b>
                        <ul>
                            <li>Always meet in public places when getting together with someone you met on Marlo.</li>
                            <li>Inform a close friend or family member of your whereabouts when meeting someone from Marlo.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>No Spam or Self-Promotion</b>
                        <ul>
                            <li>Avoid posting unsolicited promotions, advertisements, or spam content.</li>
                            <li>Respect the community's focus on genuine connections and shared interests.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>Report Concerning Behavior</b>
                        <ul>
                            <li>Use the in-app reporting tools to flag inappropriate content or concerning behavior.</li>
                            <li>Your reports help us maintain a safe and welcoming environment.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>Follow the Law</b>
                        <ul>
                            <li>Do not engage in illegal activities or promote harmful behavior.</li>
                            <li>Respect the laws of your jurisdiction and those that apply to online interactions.</li>
                        </ul>
                    </li>
                    <br />
                    <li><b>Stay Informed</b>
                        <ul>
                            <li>Familiarize yourself with Marlo's Terms of Service and Privacy Policy.</li>
                            <li>Stay updated on community announcements and changes.</li>
                        </ul>
                    </li>
                </ol>
                <br />

                Violations of these guidelines may result in warnings, suspensions, or permanent bans. We're committed to fostering a positive experience on Marlo, and we rely on our community members to uphold these standards.
                <br /><br />

                If you have questions or need clarification on any of these guidelines, please contact our support team.
                <br /><br />

                <hr style={{border: '1px solid #eee', margin: '30px 0'}} />

                <h2>Marlo Community Guidelines (Summary)</h2>
                <br />
                Welcome to Marlo! Our mission is to connect people with similar interests for unforgettable adventures and activities. To ensure a positive experience for all users, please follow these community guidelines:
                <br /><br />

                <ol>
                    <li><b>Age Requirement</b> - Marlo is intended for users aged 16 and above.</li>
                    <br />
                    <li><b>Respect Everyone</b> - Treat others as you'd like to be treated. Avoid using language that could be offensive or harmful. Harassment, hate speech, or discriminatory behavior will not be tolerated.</li>
                    <br />
                    <li><b>Stay Safe</b> - Never share personal information like your home address or financial details. When meeting someone for the first time, choose public places and let someone know your plans.</li>
                    <br />
                    <li><b>Authenticity Matters</b> - Use a genuine profile picture and be honest about your interests. Creating fake profiles or misleading others is strictly prohibited.</li>
                    <br />
                    <li><b>Keep It Relevant</b> - Only post events or activities relevant to the community's interests. Avoid spamming or sharing irrelevant content.</li>
                    <br />
                    <li><b>Respect Privacy</b> - Do not share photos or information of others without their consent. This includes screenshots of conversations or images from events.</li>
                    <br />
                    <li><b>Positive Vibes Only</b> - Encourage and uplift others. Avoid negative or derogatory comments.</li>
                    <br />
                    <li><b>No Commercial Solicitation</b> - While you're encouraged to share activities, do not use Marlo for business promotions or advertising without prior approval.</li>
                    <br />
                    <li><b>Report Inappropriate Behavior</b> - If you encounter any behavior or content that goes against these guidelines, please report it. We rely on our community to help maintain a positive environment.</li>
                    <br />
                    <li><b>Continuous Learning</b> - Embrace new activities and get to know different cultures. Our platform is a space for growth and understanding.</li>
                    <br />
                    <li><b>Follow the Law</b> - Any illegal activities or content that promotes illegal activities will be removed, and the responsible parties might be reported to the relevant authorities.</li>
                </ol>
                <br />

                Failure to adhere to these guidelines may result in warnings, suspension, or permanent banning from the Marlo community. We reserve the right to update or modify these guidelines at any time.
                <br /><br />

                Thank you for being a part of Marlo. Together, let's create a community where everyone feels welcome and inspired!
            </div>
            {!hideNav && <Footer />}
        </div>
    )
}
